import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';

import {
  wrongEmail,
  wrongNumber,
  resetAuthState,
  stateCodeToFirestore,
  isAuthentified
} from '../store/actions/authActions';
import { titleColor } from '../tools/colors';

import './css/Authentification.css';

const regexDomain = /^"?[\w-_.]*"?@orencash\.fr$/;

const Authentification = () => {
  const [email, setEmail] = useState('');
  const [numTel, setNumTel] = useState('');

  const authError = useSelector(state => state.auth.authError);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(resetAuthState());
    dispatch(isAuthentified(false));
  }, [dispatch]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    if (id === 'email') {
      setEmail(value);
    } else if (id === 'numTel') {
      setNumTel(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (regexDomain.test(email)) {
      if (isMobile) {
        if (
          numTel.length === 10 &&
          numTel[0] === '0' &&
          (numTel[1] === '6' || numTel[1] === '7')
        ) {
          submit();
        } else {
          dispatch(wrongNumber());
        }
      } else {
        submit();
      }
    } else {
      dispatch(wrongEmail());
    }
  };

  const submit = () => {
    sendMail(email);
    window.localStorage.setItem('email', email);
    window.localStorage.setItem('numTel', numTel);
    window.localStorage.setItem('validationStatus', 'false');
    navigate('/validation');
  };

  const sendMail = (emailAddr) => {
    fetch('https://us-central1-bi-secu.cloudfunctions.net/sendMail?dest=' + emailAddr)
      .then((res) => res.json())
      .then((res) => {
        dispatch(stateCodeToFirestore(emailAddr, res.code));
      });
  };

  return (
    <div
      className="container"
      style={{
        border: '1px solid',
        borderColor: titleColor,
        position: 'relative',
        top: '50px',
        backgroundColor: 'white'
      }}
    >
      <form onSubmit={handleSubmit}>
        <h1 style={{ color: titleColor }}>Authentification</h1>
        <div className="form-group">
          <label htmlFor="email" className="h4">Email</label>
          <input
            type="email"
            className="form-control"
            id="email"
            placeholder="@orencash.fr"
            onChange={handleChange}
          />
        </div>
        {isMobile && (
          <div className="mobile">
            <div className="form-group">
              <label htmlFor="numTel" className="h4">Numéro de Téléphone</label>
              <input
                type="number"
                className="form-control"
                id="numTel"
                placeholder="06 XX XX XX XX"
                onChange={handleChange}
              />
            </div>
          </div>
        )}
        <div className="form-group">
          <button className="btn btn-primary">Valider</button>
          <div className="text-danger">
            {authError && <p>{authError}</p>}
          </div>
        </div>
      </form>
    </div>
  );
};

export default Authentification;
